<template>
  <PersonalizedPaymentSteps
    class="smaller-container-wrapper"
    :heading="$t('message.eCommerceV2.personalizedPayment.stepThree.heading')"
    :currentStep="3"
  >
    <p
      data-test="stepThreeMsg"
      v-html-safe="
        $t('message.eCommerceV2.personalizedPayment.stepThree.msg', {
          creditProvider: this.getDefaultCreditDataSourceCAName.niceName,
        })
      "
    ></p>
    <tool-tip :title="tooltipTitle" :body="tooltipBody"></tool-tip>
  </PersonalizedPaymentSteps>
</template>

<script>
import { mapGetters } from 'vuex';
import PersonalizedPaymentSteps from '@/components/e-commerce-v2/layout/PersonalizedPaymentSteps.vue';
import ToolTip from '@/components/ToolTip.vue';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'StepThree',
  components: {
    PersonalizedPaymentSteps,
    ToolTip,
  },
  beforeRouteEnter: helperFunctions.onlyAcceptRoutes(['confirm-credit-form']),
  data() {
    return {};
  },
  computed: {
    ...mapGetters('ecommerceV2', ['getDefaultCreditDataSourceCAName']),
    tooltipTitle() {
      return this.getDefaultCreditDataSourceCAName.niceName;
    },
    tooltipBody() {
      return this.$t('message.eCommerceV2.creditProviderToolTipBody', {
        creditProvider: this.getDefaultCreditDataSourceCAName.niceName,
      });
    },
  },
};
</script>
